import React, {useEffect, useState} from 'react';
import history from "../../../history";
import {changeOffersEnrollment, getOffersForTournament, getTournamentEnrollmentDetails} from "../../../services/enrollments";
import {changeOffersRegistration, getRegistrationDetails, getTournamentRegistrationDetails, processPayment} from "../../../services/registrations";
import {getActiveEnrollmentDetails, getOffersForLeague} from "../../../services/enrollments";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import moment from "moment";
import Collapse from "react-bootstrap/Collapse";
import ScaleLoader from "react-spinners/ScaleLoader";
import {Col, Container, Row, Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header'
import InputSelect from '../../../components/InputSelect/InputSelect'
import LeagueCard from "../../../components/LeagueCard/LeagueCard";

// Icons
import GiftIcon from "../../../assets/images/gift.svg";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import IosArrowUp from "react-ionicons/lib/IosArrowUp";
import IosArrowDown from 'react-ionicons/lib/IosArrowDown';
import WaitingClock from '../../../assets/images/waiting_payment_icon.svg';
import AvailabilityGreenIcon from '../../../assets/images/availabilitygreen.svg';
import ChangeCircleIcon from "../../../assets/images/changecircle_black.svg";
import PaymentPendingIcon from "../../../assets/images/payment_check_grey.png";
import PaymentSuccessfulIcon from '../../../assets/images/payment_successful_icon.svg';
import MBIcon from '../../../assets/images/mb_icon.svg';
import MBWayIcon from '../../../assets/images/mbway_icon.svg';

// CSS Files
import './styles.css';

const MySwal = withReactContent(Swal);

const override = `
       display: block;
       text-align: center;
   `;

const EnrollmentDetails = (props) => {
   const [open, setOpen] = useState(false);
   const [loading, setLoading] = useState(true);
   const [details, setDetails] = useState({});
   const [leagueOffers, setLeagueOffers] = useState([]);
   const [playerOneOfferId, setPlayerOneOfferId] = useState('');
   const [playerOneOfferSizeId, setPlayerOneOfferSizeId] = useState('');
   const [playerTwoOfferId, setPlayerTwoOfferId] = useState('');
   const [playerTwoOfferSizeId, setPlayerTwoOfferSizeId] = useState('');
   const { t } = useTranslation();

   const getSizesForOffer = (offer_id) => {
      let sizes = []

      leagueOffers.map((offer) => {
         if (offer.id == offer_id) {
            if (offer.sizes[0].size_name !== "GENERIC") {
               sizes = offer.sizes;
            }
         }
      });

      return sizes;
   };

   const changeOffers = async (id, params) => {
      try {
         if (props.location.state.isRegistration) {
            await changeOffersRegistration(details.registration_id, params).then(r => sucessfulOfferChangePopUp());
         } else {
            await changeOffersEnrollment(details.enrollment_id, params).then(r => sucessfulOfferChangePopUp());
         }

         MySwal.fire({
            showCancelButton: false,
            title: t("common.success"),
            text: t("registration_details_page.success"),
            confirmButtonText: "Ok"
         }).then(() => {
            history.push("/enrollment/list")
         });
      } catch (e) {
         MySwal.fire({
            showCancelButton: false,
            title: t("common.error"),
            text: t("common.form.errors.general_alt"),
            confirmButtonText: "Ok"
         }).then(() => {
            history.push("/enrollment/list")
         });
      }
   }

   const sucessfulOfferChangePopUp = () => {
      MySwal.fire({
         showCancelButton: false,
         titleText: t("common.success"),
         text: t("registration_details_page.success"),
         confirmButtonText: "Ok"
      }).then(() => {
         history.push("/enrollment/list");
      });
   };

   let showOffers = false;
   let competitionStartDate = moment(props.location.state.isLeague ? details.league_edition_start_date : details.super_tournament_start_date);

   if (props.location.state.isRegistration) {
      let daysAfterEditionStart = moment().diff(competitionStartDate, 'days');
      showOffers = daysAfterEditionStart <= -14;
   }

   let sizes_player_one = getSizesForOffer(playerOneOfferId);
   let sizes_player_two = getSizesForOffer(playerTwoOfferId);

   let params = {
      offer_id_first_player: playerOneOfferId,
      offer_id_second_player: playerTwoOfferId,
      offer_size_id_first_player: playerOneOfferSizeId,
      offer_size_id_second_player: playerTwoOfferSizeId
   };

   let showCollapsible = details.is_paid === false && (details.payment_method === "Pagamento por transferência bancária" ||
      (details.payment_method === "Pagamento por DPG" && details.payment_generated === true));

   let hideCollapsible = details.is_paid === false && (details.payment_method === "Pagamento no clube no dia do torneio" ||
      (details.payment_method === "Pagamento por DPG" && details.payment_generated === false));

   useEffect(() => {
      let details;
      let leagueOffers;
      (async () => {
            if (props.location.state.isRegistration) {
               if (props.location.state.isLeague) {
                  details = await getRegistrationDetails(props.location.state.id);
               } else {
                  details = await getTournamentRegistrationDetails(props.location.state.id);
               }
            } else {
               if (props.location.state.isLeague) {
                  details = await getActiveEnrollmentDetails(props.location.state.id);
               } else {
                  details = await getTournamentEnrollmentDetails(props.location.state.id);
               }
            }

            if (props.location.state.isLeague) {
               leagueOffers = await getOffersForLeague(props.location.state.league_edition_id);
            } else {
               leagueOffers = await getOffersForTournament(props.location.state.super_tournament_id);
            }

            setDetails(details);
            setLeagueOffers(leagueOffers);
            setPlayerOneOfferId(details.player_one_offer_id);
            setPlayerOneOfferSizeId(details.player_one_offer_size_id);
            setPlayerTwoOfferId(details.player_two_offer_id);
            setPlayerTwoOfferSizeId(details.player_two_offer_size_id);
            setLoading(false);
         }
      )()
   }, []);

   return (
      <div>
         <Header headerBarTitle={t("registration_details_page.header")} showHeaderExtras showBackButton/>
         <Container className={"desktop"}>
            <Row>
               <Col xs={12} sm={12} lg={12} className={props.location.state.isLeague ? "mb-3" : ""}>
                  {props.location.state.isLeague ?
                     <LeagueCard
                        leagueNameClasses="card-games not-clickable pb-3"
                        leagueName={details.league + ', ' + details.league_edition}
                        leagueDate={props.location.state.isRegistration ? details.league_category : details.league_division}
                     >
                        <p className="start-date-container start-date-text">{t("registration_details_page.active_league")}</p>
                     </LeagueCard>
                     :
                     <LeagueCard
                        leagueNameClasses="card-games not-clickable pb-3 mb-3"
                        leagueName={details.tournament_name}
                        leagueDate={details.category_name}
                     >
                        <p className="start-date-container start-date-text">{t("registration_details_page.tournament")}</p>
                     </LeagueCard>
                  }
               </Col>

               {props.location.state.isRegistration &&
                  <Col xs={12} sm={12} className={"mb-3"}>
                     <ScaleLoader
                        css={override}
                        sizeUnit={"px"}
                        size={30}
                        color={'#afff55'}
                        loading={loading}
                     />
                     {!loading && showCollapsible &&
                        <div className={"collapsible-container"}>
                           <div className="d-flex justify-content-between card-padel p-2" onClick={() => setOpen(!open)} aria-controls="payment_details" aria-expanded={open}>
                              <div className={"d-flex align-items-center"}>
                                 <img src={WaitingClock} className={"icon-size p-2"}/>
                                 <p className={"color-green ml-2 payment-status"}>{t("registration_details_page.waiting_payment")}</p>
                              </div>

                              <div className={"d-flex align-items-center"}>
                                 {open
                                    ? <IosArrowUp color={"#AFFF55"}/>
                                    : <IosArrowDown color={"#AFFF55"}/>
                                 }
                              </div>
                           </div>

                           <Collapse in={open}>
                              <div id={"payment_details"} className={"pt-3 pr-2 pb-2 pl-2"}>
                                 {details.payment_method === "Pagamento por transferência bancária" &&
                                    <div>
                                       <p className={"ml-2 mb-2"}>{t("registration_details_page.payment_transfer")}</p>
                                       <p className={"ml-2"}><strong>{t("registration_details_page.payment_transfer_iban")}</strong>{details.payment_note}</p>
                                       <p className={"ml-2"}><strong>{t("registration_details_page.payment_transfer_value")}</strong>{details.payment_amount} €</p>
                                       <p className={"ml-2"}><strong>{t("registration_details_page.payment_transfer_deadline")}</strong>{details.payment_deadline}
                                       </p>
                                    </div>
                                 }
                                 {details.payment_method === "Pagamento por DPG" && details.selected_payment === "MBWAY" && details.payment_generated &&
                                    <div className={"p-2"}>
                                       <img src={MBWayIcon} className={"mbway-icon mb-3"}/>
                                       <p className={""}>{t("registration_details_page.payment_mbway")}</p>
                                    </div>
                                 }
                                 {details.payment_method === "Pagamento por DPG" && details.selected_payment === "SIBS_MULTIBANCO" && details.payment_generated &&
                                    <div>
                                       <div className={"d-flex align-items-center"}>
                                          <img src={MBIcon} className={"mb-icon p-2"}/>
                                          <div>
                                             <p className={"ml-2"}><strong>{`${t("registration_details_page.payment_mb_entity")} `}</strong>{details.entity}</p>
                                             <p className={"ml-2"}><strong>{`${t("registration_details_page.payment_mb_ref")} `}</strong>{details.reference}
                                             </p>
                                             <p className={"ml-2"}><strong>{`${t("registration_details_page.payment_mb_amount")} `}</strong>{details.payment_amount} €</p>
                                          </div>
                                       </div>

                                       <div className={"p-2"}>
                                          <p>{t("registration_details_page.payment_mb_chosen")}</p>
                                          <p>{t("registration_details_page.payment_mb_chosen_details", {day: moment(details.payment_deadline).utc(false).format("DD/MM/YYYY")})}</p>
                                       </div>
                                    </div>
                                 }
                              </div>
                           </Collapse>
                        </div>
                     }

                     {hideCollapsible &&
                        <div>
                           {details.payment_method === "Pagamento por DPG" && details.payment_generated === false &&
                              <div className={"d-flex justify-content-between card-padel p-2 pay-dpg-now"} onClick={() => history.push(`/enrollment/${details.registration_id}/payment`, {isLeague: props.location.state.isLeague})}>
                                 <div className={"d-flex align-items-center"}>
                                    <img src={PaymentPendingIcon} className={"icon-size p-2"}/>
                                    <p className={"color-green ml-2 payment-status"}>{t("registration_details_page.payment_pending")}</p>
                                 </div>

                                 <div className={"d-flex align-items-center"}>
                                    <p className={"color-green ml-2 payment-status"}>{t("registration_details_page.pay_now")}</p>
                                    <IosArrowForward color="#AFFF55"/>
                                 </div>
                              </div>
                           }

                           {details.payment_method === "Pagamento no clube no dia do torneio" &&
                              <div className={"d-flex align-items-center card-padel p-2"}>
                                 <img src={PaymentSuccessfulIcon} className={"icon-size p-2"}/>
                                 <p className={"color-green ml-2 payment-status"}>{t("registration_details_page.payment_at_event")}</p>
                              </div>
                           }
                        </div>
                     }

                     {details.is_paid === true &&
                        <div className={"d-flex align-items-center card-padel p-2"}>
                           <img src={PaymentSuccessfulIcon} className={"icon-size p-2"}/>
                           <p className={"color-green m-0 payment-status"}>
                              {`${t("registration_details_page.paid_registration")} `}
                              <span className={"payment-status"}>
                                 (<a href={details.pdf_download_link} target="_blank" className={"color-green m-0 show-receipt"}>{t("registration_details_page.paid_registration_invoice")}</a>)
                              </span>
                           </p>
                        </div>
                     }
                  </Col>
               }

               {props.location.state.isLeague &&
                  <Col xs={12} sm={12} lg={12} className={"mb-3"}>
                     <Button className={"d-flex justify-content-center w-100"} variant={"primary"} onClick={() => {
                        history.push('/availabilities', {
                           leagueId: details.league_id,
                           enrollmentId: details.enrollment_id
                        })
                     }}>
                        <img src={AvailabilityGreenIcon} alt={"availability-icon"} className={"mr-2 btn-icon"}/>
                        {t("registration_details_page.manage_availabilities")}
                     </Button>
                  </Col>
               }

               {props.location.state.isLeague &&
                  <Col xs={12} sm={12} lg={12} className={"mb-3"}>
                     <Button className={"d-flex justify-content-center w-100"} variant={"primary"} onClick={() => history.push('/substitutions')}>
                        <img src={ChangeCircleIcon} alt={"availability-icon"} className={"mr-2 btn-icon"}/>
                        {t("registration_details_page.replace_partner")}
                     </Button>
                  </Col>
               }
            </Row>
            <Row>
               <Col className={"d-flex align-items-center"}>
                  <img src={GiftIcon} className={"img-fluid p-1 mr-3"}/>
                  <div className={"mt-3"}>
                     <h2 className={"mb-0"}> Welcome Pack </h2>
                     <p>{details.welcomepack_location}</p>
                  </div>
               </Col>
            </Row>
            {!showOffers &&
               <Row className={"mt-4 mb-4 justify-content-center"}>
                  <Col className={"d-flex align-items-center warning"}>
                     <p>
                        {t("registration_details_page.offers_alert")}
                     </p>
                  </Col>
               </Row>
            }
            <Row className={"mb-4"}>
               <Col className={"d-flex align-items-center"}>
                  <div
                     style={{
                        backgroundImage: "url(" + (details.first_player_image ? details.first_player_image : process.env.PUBLIC_URL + "/img/faceless-photo.svg") + ")",
                        maxWidth: "70px"
                     }}
                     className={"profilefoto p-1 mr-3"}
                  />
                  <div className={"ml-2"}>
                     <h3 className={"mb-0"}>{t("registration_details_page.player")}</h3>
                     <p>{details.first_player_name}</p>
                  </div>
               </Col>
            </Row>
            <Row>
               <Col xs={12}>
                  <InputSelect text={t("registration_details_page.offer_type")}>
                     <select
                        onChange={(e) => {
                           setPlayerOneOfferId(e.target.value);
                           setPlayerOneOfferSizeId('');
                        }}
                        className="input-background"
                        value={playerOneOfferId !== '' ? playerOneOfferId : 'DEFAULT'}
                        disabled={!showOffers}>
                        <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                        {leagueOffers && leagueOffers.map((offer, index) => {
                           return <option key={index} value={offer.id}>{offer.offer_name}</option>
                        })}
                     </select>
                  </InputSelect>
               </Col>
               <Col xs={12}>
                  {playerOneOfferId !== '' && sizes_player_one.length !== 0 &&
                     <InputSelect text={t("registration_details_page.offer_size")}>
                        <select
                           onChange={(e) => setPlayerOneOfferSizeId(e.target.value)}
                           className="input-background"
                           value={playerOneOfferSizeId !== '' ? playerOneOfferSizeId : 'DEFAULT'}
                           disabled={!showOffers}>
                           <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                           {sizes_player_one.map((size, index) => {
                              return <option key={index} value={size.id}>{size.size_name}</option>
                           })}
                        </select>
                     </InputSelect>
                  }
               </Col>
            </Row>
            <Row className={"mb-4 mt-4"}>
               <Col className={"d-flex align-items-center"}>
                  <div
                     style={{
                        backgroundImage: "url(" + (details.partner_image ? details.partner_image : process.env.PUBLIC_URL + "/img/faceless-photo.svg") + ")",
                        maxWidth: "70px"
                     }}
                     className={"profilefoto p-1 mr-3"}
                  />
                  <div className={"ml-2"}>
                     <h3 className={"mb-0"}>{t("registration_details_page.player")}</h3>
                     <p>{details.second_player_name}</p>
                  </div>
               </Col>
            </Row>
            <Row>
               <Col xs={12}>
                  <InputSelect text={t("registration_details_page.offer_type")}>
                     <select
                        onChange={(e) => {
                           setPlayerTwoOfferId(e.target.value);
                           setPlayerTwoOfferSizeId('');
                        }}
                        className="input-background"
                        value={playerTwoOfferId !== '' ? playerTwoOfferId : 'DEFAULT'}
                        disabled={!showOffers}>
                        <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                        {leagueOffers && leagueOffers.map((offer, index) => {
                           return <option disabled={props.location.state.isLeague} key={index} value={offer.id}>{offer.offer_name}</option>
                        })}
                     </select>
                  </InputSelect>
               </Col>
               <Col xs={12}>
                  {playerTwoOfferId !== '' && sizes_player_two.length !== 0 &&
                     <InputSelect text={t("registration_details_page.offer_size")}>
                        <select
                           onChange={(e) => setPlayerTwoOfferSizeId(e.target.value)}
                           className="input-background"
                           value={playerTwoOfferSizeId !== '' ? playerTwoOfferSizeId : 'DEFAULT'}
                           disabled={!showOffers}>
                           <option value="DEFAULT" disabled>{t("common.form.options.choose_an_option")}</option>
                           {sizes_player_two.map((size, index) => {
                              return <option key={index} value={size.id}>{size.size_name}</option>
                           })}
                        </select>
                     </InputSelect>
                  }
               </Col>
            </Row>
            {showOffers && props.location.state.isLeague &&
               <Row>
                  <Col xs={12} sm={{span: 6, order: 12}} md={{span: 3, order: 12}}>
                     <Button
                        className={"mt-3"}
                        variant="primary"
                        onClick={async () => {
                           await changeOffers(props.location.state.id, params);
                        }}>{t("common.submit")}</Button>
                  </Col>
               </Row>
            }

            {details.whatsapp_link &&
               <Row>
                  <Col xs={12} className={"mt-4"}>
                     <label className="form-label">{t("registration_details_page.whatsapp_group")}</label>
                  </Col>

                  <Col xs={12}>
                     <a href={details.whatsapp_link} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                        <Col xs={8} className={"pl-0"}><p>{t("registration_details_page.join")}</p></Col>
                        <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                     </a>
                  </Col>
               </Row>
            }

            {(details.terms_url || details.documents?.length !== 0) &&
               <Row>
                  <Col xs={12} className={"mt-4"}>
                     <label className="form-label">{t("registration_details_page.documents")}</label>
                  </Col>

                  {details.terms_url &&
                     <Col xs={12}>
                        <a href={details.terms_url} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                           <Col xs={8} className={"pl-0"}><p>{t("registration_details_page.terms")}</p></Col>
                           <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                        </a>
                     </Col>
                  }

                  {details.documents?.map((document, key) => {
                     return <Col xs={12} key={key}>
                        <a href={document.link} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                           <Col xs={8} className={"pl-0"}><p>{document.name}</p></Col>
                           <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                        </a>
                     </Col>
                  })}
               </Row>
            }

            <Row>
               <Col xs={12} className={"mt-4"}>
                  <label className="form-label">{t("registration_details_page.more_information")}</label>
               </Col>

               <Col xs={12}>
                  <a href={"https://padelbox.pt/perguntas-frequentes/"} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                     <Col xs={8} className={"pl-0"}><p>{t("registration_details_page.faq")}</p></Col>
                     <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                  </a>
               </Col>

               <Col xs={12}>
                  <a href={"https://padelbox.pt/ligapadelbox/#ligas_ativas"} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                     <Col xs={8} className={"pl-0"}><p>{t("registration_details_page.renting_prices")}</p></Col>
                     <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                  </a>
               </Col>

               {props.location.state.isLeague &&
                  <Col xs={12}>
                     <a href={"https://padelbox.pt/ranking/"} target={"_blank"} className={"info-link pb-2 pt-3 ml-0"}>
                        <Col xs={8} className={"pl-0"}><p>{t("registration_details_page.padelbox_ranking")}</p></Col>
                        <Col xs={4} className={"text-right pr-0"}> <IosArrowForward fontSize="25px" color="#bbbbbb"/></Col>
                     </a>
                  </Col>
               }
            </Row>
         </Container>
      </div>
   );
}

export default EnrollmentDetails;